<h1 class="title" data-testid="screen-title">{{ text | translate }}</h1>
